import type { StorageStrategy } from "./StorageStrategy"

/**
 * Storage strategy backed by `window.localStorage`.
 * Data persists across browser sessions until explicitly cleared.
 */
class LocalStorageStrategy implements StorageStrategy {
  getItem(key: string): string | undefined {
    return window.localStorage.getItem(key) ?? undefined
  }

  setItem(key: string, value: string): void {
    window.localStorage.setItem(key, value)
  }

  deleteItem(key: string): void {
    window.localStorage.removeItem(key)
  }
}

// Exported as a module-level singleton since it is stateless.
export const localStorageStrategy = new LocalStorageStrategy()
